import React from "react";
import ContentListGrid from "../components/ContentListGrid";
import { COLLECTIONS } from "../utils/cmsSchema";

// CMS home for the Brokers slideshow on the public /aboutUs page.
// Simpler than Leadership: no per-broker detail page, no page-level
// hero settings, no SEO block — brokers only appear as a rotating
// grid of photos on About Us. Order them via `sortOrder`.
export default function BrokersList() {
  return (
    <div>
      <ContentListGrid
        schema={COLLECTIONS.brokers}
        title="About Us — Brokers Slideshow"
        subtitle="Broker portraits shown in the rotating grid on the public About Us page. There is no individual detail page — only who appears and in what order. Lower sort orders show first."
        newRoute="/cms/brokers/new"
        metaFor={() => ""}
      />
    </div>
  );
}
